export const LEFT_SIDEBAR_WIDTH = 250;
export const LEFT_SIDEBAR_COLLAPSED_WIDTH = 60;
export const ACTION_BAR_HEIGHT = 60;
export const PAGE_CONTENT_MIN_WIDTH = 600;

export const DEFAULT_RIGHT_SIDEBAR_WIDTH = 400;
export const MIN_RIGHT_SIDEBAR_WIDTH = 300;
export const MAX_RIGHT_SIDEBAR_WIDTH = 800;
